import React from 'react'
import PropTypes from 'prop-types'

import ReviewMeter from './ReviewMeter'

const ProductReviewRating = ({meter}) => (
  <div className="product-review-meters">
    <ReviewMeter title="Quality" score={meter.quality.value} />
    <ReviewMeter title="Fit" score={meter.fit.value} />
    <ReviewMeter title="Service" score={meter.service.value} />
  </div>
)

ProductReviewRating.propTypes = {
  meter: PropTypes.shape({
    quality: PropTypes.shape({
      value: PropTypes.number,
    }),
    fit: PropTypes.shape({
      value: PropTypes.number,
    }),
    service: PropTypes.shape({
      value: PropTypes.number,
    }),
  }),
}

export default ProductReviewRating
